import React from 'react';
import { Box, TextField } from '@mui/material';
import SharedFormFields, { SharedFormData } from './SharedFormFields';
import GlassImageUpload from './GlassImageUpload';
import { glassTextField, getStaggeredAnimation } from './glassMorphismStyles';

export interface SimulationFormData extends SharedFormData {
  content: string;
  imageFile: File | null;
}

interface SimulationFormFieldsProps {
  formData: SimulationFormData;
  onChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

const SimulationFormFields: React.FC<SimulationFormFieldsProps> = ({
  formData,
  onChange,
  errors = {},
}) => {
  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.name, event.target.value);
  };

  const handleImageChange = (file: File | null) => {
    onChange('imageFile', file);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, sm: 1.5 } }}>
      {/* Shared fields (Platform, Brand, Sector) */}
      <SharedFormFields
        formData={formData}
        onChange={onChange}
        errors={errors}
        animationBaseDelay={0}
      />

      {/* Post Content Field */}
      <TextField
        fullWidth
        size="small"
        name="content"
        label="Post Content *"
        placeholder="Enter your post content..."
        value={formData.content}
        onChange={handleTextChange}
        error={!!errors.content}
        helperText={errors.content}
        multiline
        minRows={2}
        maxRows={3}
        sx={{
          ...glassTextField,
          ...getStaggeredAnimation(4, 0),
          '& .MuiInputBase-inputMultiline': {
            scrollbarWidth: 'thin',
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'rgba(0, 51, 78, 0.2)',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(10, 124, 160, 0.5)',
              borderRadius: '4px',
              '&:hover': {
                background: 'rgba(10, 124, 160, 0.7)',
              },
            },
          },
        }}
      />

      {/* Image Upload */}
      <Box sx={getStaggeredAnimation(5, 0)}>
        <GlassImageUpload
          value={formData.imageFile}
          onChange={handleImageChange}
        />
      </Box>
    </Box>
  );
};

export default SimulationFormFields;
